import { useSelector } from "react-redux";

import PopupFormWrapper from "../popupFormWrapper";
import { GOALS } from "../../../../utils/tracking";

const FORM_CODE = "initOrderWithInstall";

export default function OrderWithInstall() {
  const { cityName } = useSelector((state) => state.location);

  return (
    <PopupFormWrapper
      code={FORM_CODE}
      filterField={({ CODE }) =>
        CODE !== "form_textarea_92" && CODE !== "form_text_97"
      }
      goalOpen={GOALS.orderWithElectricOpen}
      extraData={({ popupData }) => ({
        form_textarea_92: popupData?.composition,
        form_text_97: cityName,
      })}
      successText={(r) => `Заявка отправлена. Номер вашей заявки #${r.success}`}
      goalSent={GOALS.orderWithElectricSent}
    />
  );
}
